module.exports = __webpack_public_path__ + "static/bg-contact-1c897ea173d1b49b60fb0d4b2bad2bae.jpg";